<template>
  <div class="space-y-3">
    <div class="flex flex-col space-y-2 overflow-x-auto overflow-y-hidden py-2">
      <!-- Meses -->
      <div class="flex justify-around">
        <div v-for="(month, key) in listMonths" :key="key" :class="['months', textColorMonth(month)]">
          {{ month }}
        </div>
      </div>
      <div class="flex space-x-2">
        <!-- Dias -->
        <div class="grid-rows-7 grid grid-flow-col gap-0">
          <div v-for="(day, key) in listDays" :key="key" class="days">
            {{ day }}
          </div>
        </div>
        <!-- Heatmap -->
        <div class="grid-rows-7 grid grid-flow-col gap-0.5">
          <div v-for="item in stepInitialYear()" :key="item" class="h-4 w-4">&nbsp;</div>
          <div
            v-for="(item, idx) in product"
            :key="item[0]"
            :class="['boxHeatmap', boxColor(item, idx)]"
            :content="boxTooltipContent(item)"
            v-tippy="{
              arrow: true,
              arrowType: 'round',
              animation: 'scale',
              theme: 'gray',
            }"
            @click="periodSpecificDate = periodSpecificDate === item[0] ? null : item[0]"
          >
            &nbsp;
          </div>
        </div>
      </div>
    </div>
    <div class="flex space-x-6">
      <p class="inline-flex items-center space-x-1.5">
        <span class="block h-3 w-3 rounded-sm bg-[#2D3748]"></span>
        <span class="text-xs font-semibold">Sem operação</span>
      </p>
      <p class="inline-flex items-center space-x-1.5">
        <span class="block h-3 w-3 rounded-sm bg-[#1EB866]"></span>
        <span class="text-xs font-semibold">Lucro</span>
      </p>
      <p class="inline-flex items-center space-x-1.5">
        <span class="block h-3 w-3 rounded-sm bg-[#DD5B5B]"></span>
        <span class="text-xs font-semibold">Perda</span>
      </p>
      <p class="inline-flex items-center space-x-1.5">
        <span class="block h-3 w-3 rounded-sm bg-[#abafb6]"></span>
        <span class="text-xs font-semibold">Resultado igual a zero</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "marketplace-details-heatmap",
  props: {
    periodYear: {
      type: String,
      default: "ALL",
    },
    periodMonth: {
      type: String,
      default: "ALL",
    },
    product: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      count: 0,
      listDays: ["D", "S", "T", "Q", "Q", "S", "S"],
      listMonths: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
      data: [],
      periodSpecificDate: null,
    };
  },
  watch: {
    periodMonth: {
      immediate: true,
      handler(values) {
        this.periodSpecificDate = null;
        return values;
      },
    },
    periodYear: {
      immediate: true,
      handler(values) {
        return values;
      },
    },
    product: {
      immediate: true,
      handler(values) {
        return values;
      },
    },
  },
  methods: {
    boxColor(item, index) {
      const [date, value] = item;
      const splitDate = date.split("-");
      const year = splitDate[0];
      const month = this.listMonths[splitDate[1] - 1];

      if (this.periodSpecificDate != null) {
        if (this.periodSpecificDate === date) {
          if (value > 0) return "bg-ontick-green-600";
          if (value < 0) return "bg-ontick-red-600";
          if (value === 0) return "bg-ontick-steel-300";
          return "bg-ontick-steel-500";
        }
        if (value > 0) return "bg-ontick-green-600 opacity-20";
        if (value < 0) return "bg-ontick-red-600 opacity-20";
        if (value === 0) return "bg-ontick-steel-300 opacity-20";
        return "bg-ontick-steel-500 opacity-20";
      }

      if (this.periodMonth === "ALL" || (this.periodMonth === month && this.periodYear === year)) {
        if (value > 0) return "bg-ontick-green-600";
        if (value < 0) return "bg-ontick-red-600";
        if (value === 0) return "bg-ontick-steel-300";
        return "bg-ontick-steel-500";
      }

      if (value > 0) return "bg-ontick-green-600 opacity-20";
      if (value < 0) return "bg-ontick-red-600 opacity-20";
      if (value === 0) return "bg-ontick-steel-300 opacity-20";

      return "bg-ontick-steel-500 opacity-20";
    },
    boxTooltipContent(item) {
      const date = item[0].split("-").reverse().join("/");
      return `<span class="text-xs"><strong>Data:</strong> ${date} | <strong>Valor:</strong> ${
        item[1] != null ? item[1] : "-"
      }</span>`;
    },
    textColorMonth(month) {
      if (this.periodMonth === "ALL") return "text-gray-50";
      return month === this.periodMonth ? "text-gray-50" : "text-gray-50 opacity-20";
    },
    getIndexDay(day) {
      if (day === "dom.") return 0;
      if (day === "seg.") return 1;
      if (day === "ter.") return 2;
      if (day === "qua.") return 3;
      if (day === "qui.") return 4;
      if (day === "sex.") return 5;
      if (day === "sáb.") return 6;
    },
    stepInitialYear() {
      const splitDate = this.product[0][0].split("-");
      const result = new Intl.DateTimeFormat("pt-BR", {
        weekday: "short",
      }).format(new Date(Number(splitDate[0]), Number(splitDate[1]) - 1, Number(splitDate[2])));
      return this.getIndexDay(result);
    },
  },
};
</script>

<style lang="scss" scoped>
.cardHeatmap {
  @apply border-ontick-graphite-400 flex h-56 border-2;
  @apply flex flex-col flex-wrap;
  @apply justify-start;
}
.boxHeatmap {
  @apply h-4 w-4 cursor-pointer rounded-sm;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.8);
}
.days,
.months {
  @apply flex items-center text-xs text-gray-50;
}
</style>
